import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { FormField, TypeField } from '../../models/form-field.model';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss']
})
export class TextFieldComponent implements OnInit {
  
  private _fields: FormField[] = [];

  @Input()
  set fields(value: FormField[]) {
    this._fields = value;
    this.initForm(); // <--- gọi lại khi fields thay đổi
  }
  get fields(): FormField[] {
    return this._fields;
  }

  // @Input() fields: FormField[] = [
  //   {
  //     type: TypeField.Text,
  //     label: 'Name',
  //     name: 'name',
  //     defaultValue: 'John Doe'
  //   },
  //   {
  //     type: TypeField.Checkbox,
  //     label: 'Interests',
  //     name: 'interests',
  //     options: [
  //       { key: 'coding', value: 'Coding' },
  //       { key: 'music', value: 'Music' },
  //       { key: 'music1', value: 'Musicdsfsdfsdfasdfasdfsdfsdfsdf1' },
  //       { key: 'music2', value: 'Music2' },
  //       { key: 'music1', value: 'Music1' },
  //       { key: 'music1', value: 'Music1' },
  //       { key: 'music1', value: 'Music1' },
  //       { key: 'music1', value: 'Music1' },
  //     ],
  //     defaultValue: [{ key: 'coding', value: 'Coding' }]
  //   },
  //   {
  //     type: TypeField.Radio,
  //     label: 'Gender',
  //     name: 'gender',
  //     options: [
  //       { key: 'male', value: 'Male' },
  //       { key: 'female', value: 'Female' }
  //     ],
  //     defaultValue: [{ key: 'male', value: 'Male' }]
  //   }
  // ];
  @Output() submitForm = new EventEmitter<any>(); // Gửi dữ liệu form ra ngoài
  selectedFileName: string | null = null;
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    // this.form = this.fb.group({});
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(){
    this.form = this.fb.group({});
    this.fields.forEach((field) => {
      if (field.defaultValue != null) {
        if (field.type === 'checkbox' || field.type === 'multiselect') {
          // Kiểm tra xem defaultValue có phải là mảng đối tượng [{ key: string, value: string }] không
          if (Array.isArray(field.defaultValue)) {
            const defaultKeys = (field.defaultValue as { key: string; value: string }[]).map(item => item.key);
            this.form.addControl(field.name, this.fb.array(defaultKeys));
          } else {
            this.form.addControl(field.name, this.fb.array([])); // Nếu không phải mảng, khởi tạo array trống
          }
        } else if (field.type === 'radio' || field.type === 'select') {
          // Kiểm tra nếu defaultValue là đối tượng với thuộc tính key và value
          if (field.defaultValue && Array.isArray(field.defaultValue) && field.defaultValue.length > 0) {
            this.form.addControl(field.name, this.fb.control((field.defaultValue[0] as { key: string; value: string }).key || ''));
          } else {
            this.form.addControl(field.name, this.fb.control('')); // Nếu không có key, giá trị mặc định là rỗng
          }
        } else {
          this.form.addControl(field.name, this.fb.control(field.defaultValue || ''));
        }
      }
    });
  }
  
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFileName = input.files[0].name;
    }
  }

  onCheckboxChange(event: any, fieldName: string) {
    const checkboxes: FormArray = this.form.get(fieldName) as FormArray;
    if (event.target.checked) {
      checkboxes.push(this.fb.control(event.target.value));
    } else {
      const index = checkboxes.controls.findIndex((x) => x.value === event.target.value);
      checkboxes.removeAt(index);
    }
  }
  
  isCheckboxChecked(key: string, fieldName: string): boolean {
    const checkboxes: FormArray = this.form.get(fieldName) as FormArray;
    return checkboxes?.value?.includes(key);
  }

  onSubmit() {
    if (this.form.valid) {
      this.submitForm.emit(this.form.value); // Gửi dữ liệu của form
    }
  }
  
  
  // onSubmit() {
  //   const formValue = { ...this.form.value };

  //   // Định dạng lại giá trị của checkbox thành object
  //   this.fields.forEach((field) => {
  //     if (field.type === 'checkbox') {
  //       const selectedOptions = this.form
  //         .get(field.name)
  //         ?.value.map((checked: boolean, index: number) =>
  //           checked ? field.options[index] : null
  //         )
  //         .filter((option) => option !== null);
  //       formValue[field.name] = selectedOptions;
  //     } else if (field.type === 'radio') {
  //       const selectedKey = this.form.get(field.name)?.value;
  //       formValue[field.name] = field.options.find((option) => option.key === selectedKey) || null;
  //     }
  //   });

  //   console.log('Formatted Form Value:', formValue);
  // }
}
